// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.browse:hover {
    background-color:#666 !important;
  }`, "",{"version":3,"sources":["webpack://./src/app/features/popupconfirm/popupconfirm.component.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;EAClC","sourcesContent":[".browse:hover {\r\n    background-color:#666 !important;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
